(function () {
  'use strict';

  function initAccordion(root) {
    if (!root || root.dataset.psInit === 'true') return;
    root.dataset.psInit = 'true';

    var accordion = root.querySelector('[data-ps-accordion]');
    if (!accordion) return;

    var items = Array.prototype.slice.call(accordion.querySelectorAll('.ps__item'));
    if (!items.length) return;

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-ps-toggle]');
      var answer = item.querySelector('.ps__answer');
      if (!toggle || !answer) return;

      toggle.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        /* Single-open accordion: close any other open item first. */
        items.forEach(function (other) {
          if (other === item) return;
          var otherToggle = other.querySelector('[data-ps-toggle]');
          var otherAnswer = other.querySelector('.ps__answer');
          if (!otherToggle || !otherAnswer) return;
          other.classList.remove('is-open');
          otherToggle.setAttribute('aria-expanded', 'false');
          otherAnswer.hidden = true;
        });

        if (isOpen) {
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
        } else {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
        }
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-ps-section]');
    Array.prototype.forEach.call(sections, initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ps-section]');
    if (section) initAccordion(section);
  });
})();
